export class PostShipmentCreateDto {

    postShipmentId?: number;
    vesselNo?:number;
    vesselName?: string;
    marksNo?:string;
    dateOfIssue?: Date;
    lcNo?: String;
    lcName?: String;
    lcBankAddress?: String;
    lcAmount?: number;
    saleOrderId?: number;
    
    constructor(
        postShipmentId?:number,
        vesselNo?:number,
        vesselName?:string,
        marksNo?:string,
        dateOfIssue?:Date,
        lcNo?:String,
        lcName?:String,
        lcBankAddress?:String,
        lcAmount?:number,
        saleOrderId?: number
            )
            {
           this.postShipmentId=postShipmentId
           this.vesselNo=vesselNo
           this.vesselName=vesselName    
           this.marksNo=marksNo
           this.dateOfIssue=dateOfIssue
           this.lcNo=lcNo
           this.lcName=lcName
           this.lcBankAddress=lcBankAddress
           this.lcAmount=lcAmount
           this.saleOrderId=saleOrderId
        }
}

